import { render, staticRenderFns } from "./ClientEventsPage.vue?vue&type=template&id=09d43652"
import script from "./ClientEventsPage.vue?vue&type=script&lang=js"
export * from "./ClientEventsPage.vue?vue&type=script&lang=js"
import style0 from "./ClientEventsPage.vue?vue&type=style&index=0&id=09d43652&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports